import { useEffect } from 'react';

/**
 * Sets `document.title` (Replaces react-helmet, which we only used for titles)
 */
const Title = ({ children }) =>
{
	const title = [].concat(children).join('');
	useEffect(() => { document.title = title; }, [title]);
	return null;
};

export default Title;
